import { useTranslation } from 'react-i18next';
import { useActions } from 'app/hooks/useActions';
import { useAccount } from 'modules/account/accountSelector';
import { ChecklistTaskHookResult } from 'app/modules/onboardingChecklist/types';

export const useInviteTeammateTask = (): ChecklistTaskHookResult => {
  const { t } = useTranslation();
  const { userActions } = useActions('onboarding-checklist');
  const { userCount } = useAccount();

  return {
    task: {
      id: 'invite-teammate',
      title: t('onboardingChecklist.tasks.inviteTeammate.title'),
      description: t('onboardingChecklist.tasks.inviteTeammate.description'),
      ctaLabel: t('onboardingChecklist.tasks.inviteTeammate.cta'),
      isDone: typeof userCount === 'number' && userCount > 1,
      perform: () => userActions.inviteUser.perform?.(),
    },
  };
};
